<header>
  <kendo-appbar class="bg-white">
    <kendo-appbar-section>
      <a routerLink="/" class="p-0 hover:underline">
        <div class="flex flex-row items-center gap-2">
          <img src="assets/images/logo.png" class="w-[45px] h-[56px]" />
          <span class="text-xs text-neutral font-medium">{{ translationKeys.Maharah | translate }}</span>
        </div>
      </a>
    </kendo-appbar-section>

    <kendo-appbar-spacer></kendo-appbar-spacer>
    <kendo-appbar-section>
      <app-notifications></app-notifications>
    </kendo-appbar-section>
    <kendo-appbar-section>
      <kendo-dropdownbutton [svgIcon]="icons.arrowDown" fillMode="flat" buttonClass="language-switcher" [data]="languages" (itemClick)="selectLanguage($event)">
        {{ getCurrentLanguageName() | translate }}
      </kendo-dropdownbutton>
    </kendo-appbar-section>


    <span class="k-appbar-separator h-7"></span>

    <kendo-appbar-section class="actions">
      <kendo-dropdownbutton
        [svgIcon]="icons.arrowDown"
        buttonClass="flex flex-row-reverse px-4 py-[6px]"
        fillMode="flat"
        [data]="actions"
        [popupSettings]="{ animate: true }">
        <div class="flex gap-2 company-title text-dimmed text-sm">
          <img class="w-10 h-10 rounded-full" src="assets/images/account.svg" alt="" />
          <div class="flex flex-col items-start">
            <div class="font-medium title">{{ agencyName }}</div>
          </div>
        </div>
      </kendo-dropdownbutton>
    </kendo-appbar-section>
  </kendo-appbar>
</header>

<main class="mb-auto">
  <sidebar></sidebar>
  <router-outlet></router-outlet>
</main>

<footer class="flex flex-row justify-between h-[70px] p-[16px] text-sm">
  <div class="copyright flex items-center text-xs">{{ translation.Footer.Copyright | translate }}</div>
  <div class="extra flex flex-col items-center justify-around">
    <div class="contact font-bold">{{ translation.Footer.UnifiedNumber | translate }}</div>
    <div class="flex flex-row text-xs">
      <!-- <a routerLink="/FAQ" class="px-2 cursor-pointer hover:text-blue-600 transition-colors">{{ translation.Footer.FAQ | translate }}</a>
      | -->
      <span class="px-2">{{ translation.Footer.PrivacyPolicy | translate }}</span>
      |
      <span class="px-2">{{ translation.Footer.TermsOfUse | translate }}</span>
    </div>
  </div>
</footer>
